export default __webpack_public_path__ + "static/media/add-district-white.7163fb99.svg";